import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../../actions';
import PropTypes from 'prop-types';
import { FaWater, FaPlane } from 'react-icons/fa';

import styled from 'styled-components';
import {
  StyledTable,
  StyledTitle,
  StyledTd,
} from './custom-styled-components/_MyCustomSC';
import { Radio } from 'antd';

/**
 * @component
 * @category Form Page
 * @subcategory LCL/AIR Tab
 * @name LclTransportMode
 * @description Transport mode on LCL/AIR section
 * <br> <br>
 * **Example**
 * ```js
 *   <LclTransportMode />
 * ```
 */
class LclTransportMode extends Component {
  state = {};

  componentDidMount = () => {
    // this.props.updateLclAirType('lcl');
  };

  /**
   * @description it is invoked when user selects ocean or air mode
   * <br> <br>
   * **onRadioChange(e) -> {void}**
   * <br><br>
   * **Parameters:**
   * | Name          | Type          | Description  |
   * | :------------ |:------------- | :------------|
   * | e             | Event         | transport mode radio group change event |

   * Returns: Type: void
   */
  onRadioChange = (e) => {
    this.props.updateLclAirType(e.target.value);
  };

  render() {
    const { lclAirShippingType } = this.props;
    const blueColor = '#1890ff';

    return (
      <div>
        <StyledTable>
          <tbody>
            <tr>
              <th style={{ paddingLeft: '15px', fontWeight: 600 }}>
                Mode of transport
              </th>
            </tr>
            <tr>
              <StyledTd
                style={{
                  flexDirection: 'column',
                  alignItems: 'flex-start',
                  justifyContent: 'space-around',
                }}
              >
                <Radio.Group
                  onChange={this.onRadioChange}
                  value={lclAirShippingType}
                >
                  <Radio value="lcl">
                    <FaWater
                      style={{
                        marginBottom: '-2px',
                        marginRight: '10px',
                        color: lclAirShippingType === 'lcl' && blueColor,
                      }}
                    />
                    Ocean
                  </Radio>
                  <Radio value="air">
                    <FaPlane
                      style={{
                        marginBottom: '-2px',
                        marginRight: '10px',
                        color: lclAirShippingType === 'air' && blueColor,
                      }}
                    />
                    Air
                  </Radio>
                </Radio.Group>
              </StyledTd>
            </tr>
          </tbody>
        </StyledTable>
      </div>
    );
  }
}

LclTransportMode.propTypes = {
  /**
   * Whether lcl or air mode is selected
   */
  lclAirShippingType: PropTypes.string,
};

const mapStateToProps = (state) => {
  return {
    lclAirShippingType: state.form.lclAirShipping.type,
  };
};

export default connect(mapStateToProps, actions)(LclTransportMode);
